import {
  RequestSelectionBoxesStatus,
  RequestSelectionBoxesStatusType,
  RequestSelectionBoxesStep,
} from '../models/entities/request-selection-boxes.model';
import { useStore } from './store.composable';

const useRequestSelectionBoxes = () => {
  const { commit } = useStore();

  const isOpen = (status?: RequestSelectionBoxesStatusType) => {
    return status === RequestSelectionBoxesStatus.AVAILABLE;
  };

  const selectionBoxIsDone = (status?: RequestSelectionBoxesStatusType) => {
    return status === RequestSelectionBoxesStatus.DONE;
  };

  const selectionBoxClass = (
    status?: RequestSelectionBoxesStatusType,
    mainClass?: string
  ) => {
    switch (status) {
      case RequestSelectionBoxesStatus.DONE: {
        return `${mainClass}__done`;
      }
      case RequestSelectionBoxesStatus.TODO: {
        return `${mainClass}__to-do`;
      }
      default: {
        return '';
      }
    }
  };

  const closeAccordion = (emit: any) => {
    emit('closeAccordion');
  };

  const resetRequestSelectionBoxes = (shouldSkipStateReset = false) => {
    if (!shouldSkipStateReset) {
      commit('dealer', null);
      commit('selectedDealer', null);
    }

    const defaultStatus = {
      [RequestSelectionBoxesStep.RETAILER]:
        RequestSelectionBoxesStatus.AVAILABLE,
      [RequestSelectionBoxesStep.SLOT]: RequestSelectionBoxesStatus.TODO,
      [RequestSelectionBoxesStep.PERSONAL_DATA]:
        RequestSelectionBoxesStatus.TODO,
    };
    commit('requestSelectionBoxesStatus', defaultStatus);
  };

  return {
    closeAccordion,
    isOpen,
    selectionBoxIsDone,
    selectionBoxClass,
    resetRequestSelectionBoxes,
  };
};

export default useRequestSelectionBoxes;
